export const SERVER_EVENTS = {
    matchFound: 'match:found',
    matchCountdown: 'match:countdown',
    matchClock: 'match:clock',
    segmentGrace: 'segment:grace',
    matchResult: 'match:result',
    reaction: 'reaction:recv',
    rematchState: 'rematch:state',
    minigameState: 'minigame:state',
    segmentAdvance: 'segment:advance',
    opponentProgress: 'opponent:progress',
    opponentDisconnected: 'opponent:disconnected',
    opponentReconnected: 'opponent:reconnected',
    roomCreated: 'room:created',
    queueStatus: 'queue:status',
    eventRejected: 'event:rejected',
    error: 'error',
};
//# sourceMappingURL=server-messages.js.map